import {
  nrkLogoNrkRadioOnDark,
  nrkLogoNrk,
  nrkLogoNrkTvOnDark,
} from '@nrk/core-icons/logo';

export const categories = [
  'Mer Stjernekamp!',
  'Maskorama er tilbake!',
  'Le og bli underholdt',
  'Lære og bli opplyst',
  'Roe ned',
  'Sosialt',
] as const;

export const laat_for_laat_url =
  'https://www.nrk.no/anmeldelser/anmeldelse_-stjernekamp-2023-finale-_-4.-november-1.16619506';

type Category = (typeof categories)[number];

type basePromo = {
  title: string;
  description: string;
  href: string;
  img: string;
  category: Category;
  contentId?: string;
};

const sourceMediums = ['tv', 'radio', ''] as const;
export type SourceMedium = (typeof sourceMediums)[number];

export type FavouriteContentType = 'series' | 'programs' | 'podcast' | '';

export interface Promo extends basePromo {
  logo: {
    html: string;
    alt: string;
  };
  sourceMedium: SourceMedium;
  favouriteContentType: FavouriteContentType;
  contentId: string;
}

const nrkLogo = {
  html: nrkLogoNrk,
  alt: 'NRK',
};

const radioLogo = {
  html: nrkLogoNrkRadioOnDark,
  alt: 'NRK Radio',
};

const tvLogo = {
  html: nrkLogoNrkTvOnDark,
  alt: 'NRK TV',
};

const getFavouriteContentType = (contentType: string): FavouriteContentType => {
  switch (contentType) {
    case 'serie':
      return 'series';
    case 'program':
      return 'programs';
    case 'podkast':
      return 'podcast';
    default:
      return '';
  }
};

const addData = (basePromos: Array<basePromo>): Array<Promo> => {
  const result: Array<Promo> = [];

  basePromos.forEach((p) => {
    const parts = p.href.split('/');
    if (parts.length >= 4) {
      let sourceMedium = parts[2].split('.')[0];
      sourceMedium = sourceMediums.some((sm) => sm === sourceMedium)
        ? sourceMedium
        : '';
      const favouriteContentType = getFavouriteContentType(parts[3]);
      const contentId = p.contentId ?? parts[4] ?? '';

      if (sourceMedium !== '') {
        result.push({
          ...p,
          logo: sourceMedium === 'radio' ? radioLogo : tvLogo,
          sourceMedium: sourceMedium as SourceMedium,
          favouriteContentType: favouriteContentType,
          contentId,
        });
      } else {
        result.push({
          ...p,
          logo: nrkLogo,
          sourceMedium: '',
          favouriteContentType: '',
          contentId,
        });
      }
    }
  });

  return result;
};

export const promos: Array<Promo> = addData([
  {
    title: 'Se din favoritt om igjen',
    description: 'Er du enig med anmelderen?',
    href: laat_for_laat_url,
    img: 'https://gfx.nrk.no/gSMmH2H3vG_RhaAK9ozztwCSYesCkdm5ODmsu6MxuYuQ',
    category: categories[0],
    contentId: 'anmeldelser',
  },
  {
    title: 'Maskorama er tilbake',
    description: 'Hvem skjuler seg bak årets masker?',
    href: 'https://www.nrk.no/kultur/hvem-skjuler-seg-bak-arets-masker_-1.16608118',
    img: 'https://gfx.nrk.no/41nVjkPBpWV_zr-tmZSkiQm0n8C1n2HN2OInD5gYELfA',
    category: categories[1],
    contentId: 'anmeldelser',
  },
  {
    title: 'Aldri en fredag uten',
    description: 'Nytt på nytt',
    href: 'https://tv.nrk.no/serie/nytt-paa-nytt',
    img: 'https://gfx.nrk.no/ktpwgD2DS18Id_btjAAspgas865fBqYbuxKObisplpug',
    category: categories[2],
  },
  {
    title: 'Verdens mest idiotiske sport',
    description: 'Helt Ramme sporter',
    href: 'https://tv.nrk.no/serie/helt-ramme-sporter/sesong/2',
    img: 'https://gfx.nrk.no/bOr4n7u5CtGDWdYZCC9esQTBibHjuKWtJSP6hi5S2bKg',
    category: categories[2],
  },
  {
    title: 'Det vi snakker om',
    description: 'Oppdatert',
    href: 'https://radio.nrk.no/podkast/oppdatert',
    img: 'https://gfx.nrk.no/PNuB6f5e5TzOZ_S6hq-8mQ5789dGz4VWt1SrGk9nJKXA',
    category: categories[3],
  },
  {
    title: 'Tenketank for folk med lav intelligens',
    description: 'Både Erlend og Steinar',
    href: 'https://radio.nrk.no/podkast/baade_erlend_og_steinar_',
    img: 'https://gfx.nrk.no/EYtKJsm1DDT3yI5RMcfEzAL1Y0sxVeUe0l497iL4hONg',
    category: categories[3],
  },
  {
    title: 'En gjenganger på podtoppen',
    description: 'Historier fra virkeligheten',
    href: 'https://radio.nrk.no/podkast/radiodokumentaren',
    img: 'https://gfx.nrk.no/XHleEz7xWz25D6PSRI55jQwehP-2Ul3R03Rpx3o8Riqw',
    category: categories[4],
  },
  {
    title: 'Bare én overlevde orkanen',
    description: 'Hele historien: Alene i Atlanteren',
    href: 'https://radio.nrk.no/podkast/hele_historien/sesong/alene-i-atlanteren',
    img: 'https://gfx.nrk.no/4dxEfTo3EgIfAen_8UEoywP2zIuMdozTFGlCMQnIllIg',
    category: categories[4],
  },
  {
    title: 'Kjenner du igjen disse norske musikkvideoene?',
    description: 'Musikk-quiz',
    href: 'https://www.nrk.no/kultur/quiz_-kjenner-du-igjen-disse-norske-musikkvideoene_-1.15419849',
    img: 'https://gfx.nrk.no/oiDhte5_Aq_FWNUxX-uBKww2vHfSAURf_HMUGtyL349g',
    category: categories[5],
  },
]);

export default promos;
